import { PERMISSIONS } from '../constants/permissions';
import { hasPermission } from '../utils/permissions';

/**
 * Shift module capabilities from mounted arkhrmsapi routes.
 *
 * Mounted:
 * - GET /shifts (search + pagination)
 * - POST /shifts
 * - PUT /shifts/:shiftId
 *
 * Not mounted:
 * - GET /shifts/:shiftId (details use search ownership)
 * - DELETE /shifts/:shiftId
 *
 * Installed permissions are SETTINGS_VIEW and SETTINGS_UPDATE.
 * Swagger labels SHIFT.READ/CREATE/UPDATE map to those codes.
 */
export const SHIFT_ROUTE_CAPABILITIES = {
  list: true,
  create: true,
  update: true,
  detailsById: false,
  delete: false,
} as const;

export type ShiftModuleCapabilities = {
  canViewShifts: boolean;
  canCreateShift: boolean;
  canUpdateShift: boolean;
};

export function getShiftModuleCapabilities(
  permissions: readonly string[],
): ShiftModuleCapabilities {
  const canView = hasPermission(permissions, PERMISSIONS.SETTINGS_VIEW);
  const canUpdate = hasPermission(permissions, PERMISSIONS.SETTINGS_UPDATE);

  return {
    canViewShifts: canView && SHIFT_ROUTE_CAPABILITIES.list,
    canCreateShift: canUpdate && SHIFT_ROUTE_CAPABILITIES.create,
    canUpdateShift: canUpdate && SHIFT_ROUTE_CAPABILITIES.update,
  };
}
